<template>
	<path
		d="M4.5 13.1h7.3a3.2 3.2 0 0 0 .6-6.34A4.1 4.1 0 0 0 4.6 5.9 3.6 3.6 0 0 0 4.5 13.1Z"
		fill="none"
		stroke="currentColor"
		stroke-width="1.3"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</template>
